module.exports = __webpack_public_path__ + "static/img/home-swiper-1.e23f5ce3.png";